var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.graduatedPrices[0]
    ? _c("div", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$translate("Ceres::Template.singleItemGraduatedPrices")
            ) + ":"
          )
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "graduated-prices-table" },
          _vm._l(_vm.graduatedPrices, function(price, index) {
            return _c("tr", { key: index }, [
              _c(
                "td",
                { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.singleItemMinimumQuantity"
                        )
                      ) +
                      " " +
                      _vm._s(price.minimumOrderQuantity) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(price.unitPrice.formatted) +
                      "\n      "
                  )
                ]
              )
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }